import { graphql } from '../../../graphql/generated';

export const MARK_ORDER_FILE_PRINTED_MUTATION = graphql(`
  mutation MarkOrderFilePrinted($orderFileId: ID!) {
    markOrderFilePrinted(orderFileId: $orderFileId) {
      id
      printedAt
    }
  }
`);
